angular.module('SpidApp')

.filter('calendar', function () {
    return function (date) {
        return moment(date).calendar();
    }
})

.filter('longdate', function () {
    return function (date) {
    	if(!date) {
    		return ''
    	}
        return moment(date).format('LLLL'); 
    }
})

.filter('shortdate', function () {
    return function (date) { 
    	if(!date) {
    		return ''
    	}
        return moment(date).format('LLL');
    }
})

.filter('year', function () {
    return function (date) { 
    	if(!date) {
    		return ''
    	}
        return moment(date).format('YYYY');
    }
})

.filter('month', function () {
    return function (date) { 
    	if(!date) {
    		return ''
    	}
        return moment(date).format('MMMM');
    }
})